import React, { Component } from 'react';
import { connect } from 'react-redux';

/* Function */
import ObjGeneral from '../function/';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Components */
import Title from '../../components/reports/title';
import Message from '../../components/common/message';
import MessageWithIcon from '../../components/common/messageWithIcon';

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasErrorUrl: false,
      msgErrorTitle: '',
      msgError: ''
    };
  }

  componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('reports') || permits.includes('reports');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);

        if (obj.generalSetting.views.includes('reports')) {
          let msgError = '';
          let msgErrorTitle = '';
          const msgUrlEmpty = this.props.language.nav.reports.urlEmpty;
          const msgUrlEmptyTitle = this.props.language.nav.reports.urlEmptyTitle;
      
          if (!obj.hasOwnProperty('reports')) {
            msgErrorTitle = msgUrlEmptyTitle;
            msgError = msgUrlEmpty;
          } else if (!obj.reports.hasOwnProperty('externalUrl')) {
            msgErrorTitle = msgUrlEmptyTitle;
            msgError = msgUrlEmpty;
          } else if (obj.reports.externalUrl === null || obj.reports.externalUrl === '') {
            msgErrorTitle = msgUrlEmptyTitle;
            msgError = msgUrlEmpty;
          } else if (!ObjGeneral.isValidUrl(obj.reports.externalUrl)) {
            msgErrorTitle = this.props.language.nav.reports.invalidUrlTitle;
            msgError = this.props.language.nav.reports.invalidUrl.replace('{externalUrl}', obj.reports.externalUrl);
          }

          if (msgError) {
            this.setState({
              hasErrorUrl: true,
              msgError,
              msgErrorTitle
            });
          }
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);

      return (
        <section className="main full-height">
          <div className="main-container">
            <Title language={this.props.language} />
            { 
              (this.state.hasErrorUrl) && (
                <div className="reports-container-message flex align-center justify-center">
                  <MessageWithIcon
                    title={this.state.msgErrorTitle}
                    message={this.state.msgError}
                    icon="fas fa-exclamation-triangle"
                  />
                </div>
              )
            }
            {
              (obj.reports && !this.state.hasErrorUrl) && (
                <iframe
                  src={obj.reports.externalUrl}
                  className="reports-container"
                />
              )
            }
          </div>
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  language: state.reducer.dashboard.language,
  setting: state.reducer.dashboard.setting,
});
const mapDispatchToProps = () => ({});
Reports.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reports);



// WEBPACK FOOTER //
// ./source/client/containers/reports/index.jsx